import { z } from 'zod';
import { CALIDADES_LEAD, FUENTES_LEAD } from '../enums.js';
// ---------------------------------------------------------------------------
// ciclo-emisor: las campañas de envío (la app le escribe a una lista fija).
// El menú de filtros es CERRADO: cada uno sobre un dato que existe y está
// cargado (medido el 19/10). Mismas formas que `FiltrosAudiencia` del backend.
// ---------------------------------------------------------------------------
export const ORIGENES_PERSONA = ['APP', 'NOTION', 'SCRAPER'];
export const RANGOS_ULTIMO_ENTRANTE = ['MENOS_30', 'DE_30_A_90', 'MAS_90', 'NUNCA'];
export const ESTADOS_ENVIO = [
    'PENDIENTE',
    'ENVIADO',
    'ENTREGADO',
    'NO_ENTREGADO_48H',
    'SIN_WHATSAPP',
    'SALTEADO',
];
// BORRADOR = nunca se activó (la lista no está fija); PAUSADA = se activó y se bajó.
export const ESTADOS_CAMPANA_ENVIO = ['BORRADOR', 'ACTIVA', 'PAUSADA', 'TERMINADA'];
export const filtrosAudienciaSchema = z
    .object({
    origenes: z.array(z.enum(ORIGENES_PERSONA)).min(1),
    ultimoEntrante: z.array(z.enum(RANGOS_ULTIMO_ENTRANTE)).optional(),
    etapaMin: z.number().int().min(1).max(5).optional(),
    etapaMax: z.number().int().min(1).max(5).optional(),
    calidades: z.array(z.enum(CALIDADES_LEAD)).optional(),
    fuentes: z.array(z.enum(FUENTES_LEAD)).optional(),
    campanasOrigen: z.array(z.string().min(1)).optional(),
    paises: z.array(z.string().length(2)).optional(),
    descansoDias: z.number().int().min(1).max(365).optional(),
})
    .refine((f) => f.etapaMin === undefined || f.etapaMax === undefined || f.etapaMin <= f.etapaMax, {
    message: 'La etapa "desde" no puede ser mayor que "hasta"',
    path: ['etapaMax'],
});
export const plantillaInputSchema = z.object({
    // Con id: se actualiza esa. Sin id: se crea. Nunca se borra (se desactiva).
    id: z.string().min(1).optional(),
    nombre: z.string().trim().min(1).max(60),
    texto: z.string().trim().min(5).max(1000),
    activa: z.boolean().default(true),
});
const ritmo = {
    topeDiario: z.number().int().min(1).max(50),
    intervaloMin: z.number().int().min(5).max(240),
    horaInicio: z.number().int().min(0).max(23),
    horaFin: z.number().int().min(1).max(24),
};
export const emisionCrearSchema = z
    .object({
    nombre: z.string().trim().min(2).max(80),
    filtros: filtrosAudienciaSchema,
    plantillas: z.array(plantillaInputSchema).min(1),
    ...ritmo,
    vigenteDesde: z.coerce.date().optional(),
    vigenteHasta: z.coerce.date().nullable().optional(),
})
    .refine((c) => c.horaInicio < c.horaFin, {
    message: 'La franja termina antes de empezar',
    path: ['horaFin'],
});
// Con la campaña ya activada, la lista es fija: los filtros no se cambian (el
// backend responde LISTA_FIJA). El ritmo y las plantillas sí (decisión de Javier).
export const emisionActualizarSchema = z
    .object({
    nombre: z.string().trim().min(2).max(80),
    filtros: filtrosAudienciaSchema,
    plantillas: z.array(plantillaInputSchema).min(1),
    topeDiario: ritmo.topeDiario,
    intervaloMin: ritmo.intervaloMin,
    horaInicio: ritmo.horaInicio,
    horaFin: ritmo.horaFin,
    vigenteHasta: z.coerce.date().nullable(),
    activa: z.boolean(),
})
    .partial()
    .refine((c) => Object.keys(c).length > 0, { message: 'Nada para actualizar' });
export const audienciaConsultaSchema = z.object({ filtros: filtrosAudienciaSchema });
export const pruebaEnvioSchema = z.object({
    numero: z.string().trim().min(8).max(20),
    plantillaId: z.string().min(1).optional(),
    // Para probar un texto todavía sin guardar.
    texto: z.string().trim().min(5).max(1000).optional(),
});
//# sourceMappingURL=emision.js.map